import { Component, Input, OnInit } from '@angular/core';
import { MainEntryService, MainEntryState } from '../../../components/main-entry';
import { PrivacyAndTermsAndConditionsService } from './privacy-and-terms-and-conditions.service';
import { ActivatedRoute } from '@angular/router';
import { ApiResponse } from '../../../definitions/api-response.interface';
import { AemLabelsPolicy, AemLabelsTnC } from '../../../components/shell/shell.interface';

@Component({
	selector: 'tmhna-portal-privacy-and-terms-and-conditions',
	templateUrl: './template/privacy-and-terms-and-conditions.component.html',
	styleUrls: ['./template/privacy-and-terms-and-conditions.component.scss']
})
export class PrivacyAndTermsAndConditionsComponent implements OnInit
{
  @Input() set mainState(value: MainEntryState)
	{
		this.mainEntryservice.updateState(value);
	}
  get mainState(): MainEntryState
  {
  	return this.mainEntryservice.state;
  }
  contentPagelabels = {
  	heading: 'terms & conditions'
  };
  isPrivacyPage: boolean = false;
  contentData: string[] = [];
  constructor(private readonly mainEntryservice: MainEntryService, private readonly contentService: PrivacyAndTermsAndConditionsService, private readonly route: ActivatedRoute) { }

  ngOnInit(): void 
  {
  	this.route.params.subscribe(params => 
  	{
  		const type = params['type'];
  		if(type === 'privacy') 
  		{
  			this.isPrivacyPage = true;
  			this.getPrivacyData();
  		}
  		else if(type === 'terms')
  		{
  			this.isPrivacyPage = false;
  			this.getTermsData();
  		}
  		else 
  		{
  			this.getTermsData();
  		}
  	});
  	this.mainEntryservice.getLandingPageAemLabels();
  	this.getContentPageLabels();
  }
  getContentPageLabels() 
  {
  	this.contentService.getContentPageData().subscribe({
  		next: (res) => 
  		{
  			if(res) 
  			{
  				this.contentPagelabels = this.isPrivacyPage ? res.privacy : res.terms;
  			}
  		},
  		error: () => 
  		{
  		}
  	});
  }
  getPrivacyData() 
  {
  	this.contentService.getPrivacyPolicyData().subscribe({
  		next: (res) => 
  		{
  			if(res) 
  			{
  			  const data = <AemLabelsPolicy>res.data;
  			  this.contentData = data.updatedPrivacy.content;
  			}
  		},
  		error: () => 
  		{
  		}
  	});
  }

  getTermsData() 
  {
  	this.contentService.getTermsAndConditionsData().subscribe({
  		next: (res: ApiResponse) => 
  		{
  			if(res?.data) 
  			{
  				const data = <AemLabelsTnC>res.data;
  				this.contentData = data.updatedTerms.content;
  			}
  		},
  		error: () => 
  		{
  		}
  	});
  }
}
